import { render } from "./predictive-search.vue?vue&type=template&id=3f4b6aac"
import script from "./predictive-search.vue?vue&type=script&lang=js"
export * from "./predictive-search.vue?vue&type=script&lang=js"

import "./predictive-search.vue?vue&type=style&index=0&id=3f4b6aac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__